import * as React from 'react';
import { PublicPageProvider } from '../../_contexts/PublicPageContext';
import { PublicLearningPageWrapper } from '../../../designSystem/layouts/pageWrappers/PublicLearningPageWrapper';
import { LearningModuleList } from '../../_components/learning/LearningModuleList';

export function LearningModuleListPublicPage(): JSX.Element {

    return (
        <PublicPageProvider partner='Joblife'>
            <PublicLearningPageWrapper>
                <LearningModuleList isPublic />
            </PublicLearningPageWrapper>
        </PublicPageProvider>
    );
}